import React, { useState } from 'react';
import { Grid, TextField, Box, Button, CardActions, InputAdornment, Typography, LinearProgress } from '@mui/material';
import { Add, Search } from '@mui/icons-material';
import CategoryFilter from './CategoryFilter';
import ProductCard from './ProductCard';
import ProductQuickAdd from './ProductQuickAdd';
import useMasterProducts from '../hooks/useMasterProducts';

export default function MasterProductBrowser({ retailerId }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quickAddOpen, setQuickAddOpen] = useState(false);

  const { products, isLoading } = useMasterProducts({
    query: searchQuery,
    category: selectedCategory
  });

  const handleAddProduct = (masterProduct) => {
    setSelectedProduct(masterProduct);
    setQuickAddOpen(true);
  };

  return (
    <Box>
      <Grid container spacing={3}>
        {/* Filters */}
        <Grid item xs={12} md={3}>
          <CategoryFilter
            selectedCategory={selectedCategory}
            onCategoryChange={setSelectedCategory}
          />
        </Grid>

        {/* Product Grid */}
        <Grid item xs={12} md={9}>
          <TextField
            fullWidth
            placeholder="Search products by name, brand, or UPC..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ mb: 3 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />

          {isLoading && <LinearProgress sx={{ mb: 2 }} />}

          {!isLoading && products.length === 0 && searchQuery.length >= 2 && (
            <Box sx={{ textAlign: 'center', py: 8 }}>
              <Typography variant="h6" color="text.secondary">
                No products found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Try a different search term or browse by category
              </Typography>
            </Box>
          )}

          {!isLoading && searchQuery.length < 2 && !selectedCategory && (
            <Box sx={{ textAlign: 'center', py: 8 }}>
              <Typography variant="h6" color="text.secondary">
                Start searching or select a category
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Search for products or browse our master catalog by category
              </Typography>
            </Box>
          )}

          <Grid container spacing={2}>
            {products.map((product) => (
              <Grid item xs={12} sm={6} md={4} key={product.id}>
                <ProductCard product={product}>
                  <CardActions>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<Add />}
                      onClick={() => handleAddProduct(product)}
                    >
                      Add to Inventory
                    </Button>
                  </CardActions>
                </ProductCard>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      {/* Quick Add Dialog */}
      <ProductQuickAdd
        open={quickAddOpen}
        onClose={() => setQuickAddOpen(false)}
        masterProduct={selectedProduct}
        retailerId={retailerId}
      />
    </Box>
  );
}
